import { Component, Input } from '@angular/core';

import { Registration, WorkerRegistration } from '../../models/registration';
import { HoursOption } from 'src/app/shared/models/hours-option';
import { WorkerAndToolService } from 'src/app/shared/services/worker-and-tool.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-worker-details',
    imports: [],
    templateUrl: './worker-details.component.html',
    styleUrl: './worker-details.component.scss'
})

export class WorkerDetailsComponent {

  @Input() workerRegistrations!: WorkerRegistration[];
  @Input() currentPhaseCode!: string;
  @Input() option!: HoursOption;


  private costMap: { [code: string]: string } = {};
  displayWorkerRegistrations: Array<WorkerRegistration & { costDescription?: string }> = [];

  private costSubscription?: Subscription;

  //multiplePhases!: boolean

  constructor(private workerService: WorkerAndToolService) {
    this.loadCosts();



    this.workerRegistrations = this.workerRegistrations?.filter(x => x.phaseCode == this.currentPhaseCode)



    //this.multiplePhases = this.option.multiplePhases!;
    // boh serve e non serve ---> il lavoro pesante lo fa la pagina html

    // TEST 
    console.log(this.workerRegistrations);
    console.log(this.currentPhaseCode);
  }



  private loadCosts(): void {
    // Recupera l'elenco completo di WorkerCosts (codice -> descrizione)
    this.costSubscription = this.workerService.getcostObservable().subscribe({
      next: (workerCosts) => {
        this.costMap = {};
        (workerCosts ?? []).forEach(c => {
          if (c && c.costCode) {
            this.costMap[c.costCode] = c.costDescription;
          }
        });
        // ricostruisco la lista visualizzata con le descrizioni aggiornate
        this.buildDisplayList();
      },
      error: (err) => {
        console.error('Errore caricamento workerCosts', err);
        // se fallisce mostra il codice (buildDisplayList già gestisce fallback)
        this.buildDisplayList();
      }
    });
  }

  private buildDisplayList(): void {
    if (!this.workerRegistrations) {
      this.displayWorkerRegistrations = [];
      return;
    }

    this.displayWorkerRegistrations = this.workerRegistrations
      .filter(x => x.phaseCode == this.currentPhaseCode)
      .map(x => ({
        ...x,
        costDescription: x.cost ? (this.costMap[x.cost] ?? x.cost) : ''
      }));
  }


  /*
  private async loadCosts(): Promise<void> {
    try {
      const costs = await this.workerService.getCosts();
      costs.forEach(c => {
        if (c && c.costCode) this.costMap[c.costCode] = c.costDescription;
      });
    } catch (e) {
      // ignoro errori di caricamento costi: mostreremo il codice se non disponibile
      console.error('Errore caricamento costi', e);
    } finally {
      this.buildDisplayList();
    }
  }

  private buildDisplayList(): void {
    if (!this.workerRegistrations) {
      this.displayWorkerRegistrations = [];
      return;
    }

    this.displayWorkerRegistrations = this.workerRegistrations
      .filter(x => x.phaseCode == this.currentPhaseCode)
      .map(x => ({
        ...x,
        costDescription: x.cost ? (this.costMap[x.cost] ?? x.cost) : ''
      }));
  }
  */

}






//copy!: WorkerRegistration[]
//copy: any[] | undefined;

//@Input() workerRegistrations: any[] | undefined; //WorkerRegistration[];
//@Input() currentPhaseCode: any | undefined;

//@if (workerRegistrations.filter(item => item.phaseCode == currentPhaseCode).length > 0) {

//this.copy = this.workerRegistrations.filter(item => item.phaseCode == this.currentPhaseCode)
//this.copy = this.workerRegistrations;
